// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {createPipCodeRequestPayload} from '../services/create-pip-code-request-payload';
import {postPipCode} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const createPipCodeRequest = () =>

    async dispatch => {

        const payload = createPipCodeRequestPayload();

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await postPipCode(payload);

            successAlertBar(translate('PIP_CODE_CREATED_SUCCESSFULLY'));

            dispatch(routerActions.goBack());

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/submit-pip-code-request.js